import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SvgIcons from "../svgIcons";

function SecondRegionStepper({ steps, activeStep, noIcon, onStepChange }) {
  const navigate = useNavigate();

  const handleKeyDown = (e, index) => {
    if (e.key === "Enter" || e.key === " ") {
      navigate(steps[index].link);
      onStepChange?.(index);
    }

    if (e.key === "ArrowRight") {
      const next = (index + 1) % steps.length;
      document.getElementById(`tab-${next}`)?.focus();
    }

    if (e.key === "ArrowLeft") {
      const prev = (index - 1 + steps.length) % steps.length;
      document.getElementById(`tab-${prev}`)?.focus();
    }
  };

  return (
    <Box
      role="tablist"
      aria-label="Region steps"
      sx={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        borderBottom: "1px solid #e0e0e0",
        gap: "4px",
      }}
    >
      {steps?.map((step, index) => {
        const isActive = activeStep === index;

        return (
          <Box
            key={index}
            role="tab"
            tabIndex={0}
            aria-selected={isActive}
            onClick={() => {
              navigate(step.link);
              onStepChange?.(index);
            }}
            onKeyDown={(e) => handleKeyDown(e, index)}
            sx={{
              flex: 1,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: 2,
              py: 1.5,
              border: "1px solid #E0E0E0",
              borderBottom: "none",
              borderRadius: "12px 12px 0 0",
              fontWeight: 600,
              bgcolor: isActive ? "#F2B600" : "#fff",
              "&:focus": {
                outline: "3px solid #005fcc",
                outlineOffset: "2px",
              },
            }}
          >
            {step.label}
          </Box>
        );
      })}
    </Box>
  );
}

SecondRegionStepper.propTypes = {
  steps: PropTypes.array,
  activeStep: PropTypes.number,
  noIcon: PropTypes.bool,
  onStepChange: PropTypes.func,
};

export default SecondRegionStepper;